<template>
	<div  v-if="loaded">
		<div class="md-layout">
			<div class="md-layout-item md-small-size-100 md-size-50">
				<md-field>
					<label>ឈ្មោះក្រុមហ៊ុន / សហគ្រាស</label>
					<md-input type="text" v-model="company.name"></md-input>
				</md-field>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-25">
				<md-field>
					<label>ឈ្មោះម្ចាស់ក្រុមហ៊ុន</label>
					<md-input type="text" v-model="company.owner"></md-input>
				</md-field>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-25">
				<md-field>
					<label>សញ្ជាតិម្ចាស់ក្រុមហ៊ុន</label>
					<md-input type="text" v-model="company.nationality">
					</md-input>
				</md-field>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-25">
				<md-field>
					<md-select placeholder="ប្រភេទអាជ្ញាបណ្ណ" v-model="company.type">
						<md-option v-for="business in businessList" :value="business.id">{{business.name}}</md-option>
					</md-select>
				</md-field>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-20">
				<md-field>
					<label>លេខអាជ្ញាបណ្ណ</label>
					<md-input type="text" v-model="company.number" />
				</md-field>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-20">
				<md-field>
					<md-select placeholder="ខេត្ត / ក្រុង" v-model="company.location">
						<md-option v-for="location in locationList" :value="location.id">{{location.name}}</md-option>
					</md-select>
				</md-field>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-35">
				<md-field>
					<label>ទីតាំងអាជីវកម្ម</label>
					<md-input type="text" v-model="company.address" />
				</md-field>
			</div>


			<div class="md-layout-item md-small-size-100 md-size-33">
				<md-field>
					<label>ថ្ងៃចេញអាជ្ញាបណ្ណ</label>
					<datetime type="date" v-model="company.issue"></datetime>
					<md-input type="text" style="display: none" v-model="company.issue" />
				</md-field>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-33">
				<md-field>
					<label>ថ្ងៃគិតសុពលភាព</label>
					<datetime type="date" v-model="company.active"></datetime>
					<md-input type="text" style="display: none" v-model="company.active" />
				</md-field>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-33">
				<md-field>
					<label>ថ្ងៃផុតសុពលភាព</label>
					<datetime type="date" v-model="company.expiry"></datetime>
					<md-input type="text" style="display: none" v-model="company.expiry" />
				</md-field>
			</div>

			<div class="md-layout-item md-small-size-100 md-size-20">
				<md-field>
					<label>ផ្ទៃក្រទ្បាដី</label>
					<md-input type="number" v-model="company.area" />
				</md-field>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-20">
				<md-field>
					<md-select placeholder="ស្ថានភាព" v-model="company.status">
						<md-option v-for="status in statusList" :value="status.id">{{status.name}}</md-option>
					</md-select>
				</md-field>
			</div>

			<div class="md-layout-item md-small-size-100 md-size-20">
				<md-field>
					<label>ទូរស័ព្ទទំនាក់ទំនង</label>
					<md-input type="text" v-model="company.phone" />
				</md-field>
			</div>
			<div class="md-layout-item md-small-size-100 md-size-40">
				<md-field>
					<label>ផ្សេងៗ</label>
					<md-input type="text" v-model="company.note" />
				</md-field>
			</div>
		</div>
		<div class="md-layout" style="margin-top: 13px">
			<div class="md-layout-item md-small-size-100 grid-8">
				អាជ្ញាបណ្ណ<br>
				<input type="file" ref="file1" style="display: none;" @change="processFile($event, 'file1')">
				<img class="thumb-product" src="/note_add.png" v-if="company.file1.length == 0">
				<img class="thumb-product" src="/loading-image.gif" v-if="company.file1 == 'loading'">
				<img class="thumb-product" src="/image-upload.png"
					v-if="company.file1.length > 0 && company.file1 != 'loading'"><br>
				<md-progress-bar v-if="progress.file1.show" md-mode="determinate" :md-value="progress.file1.value">
				</md-progress-bar>
				<md-button class="md-primary" @click="openImage('file1')" v-if="company.file1.length == 0">ផ្ទុកឡើង
				</md-button>
				<md-button class="md-danger" @click="removeImage('file1')" v-else>ដកចេញ</md-button>
			</div>

			<div class="md-layout-item md-small-size-100 grid-8">
				ផែនការអាជីវកម្ម<br>
				<input type="file" ref="file2" style="display: none;" @change="processFile($event, 'file2')">
				<img class="thumb-product" src="/note_add.png" v-if="company.file2.length == 0">
				<img class="thumb-product" src="/loading-image.gif" v-if="company.file2 == 'loading'">
				<img class="thumb-product" src="/image-upload.png"
					v-if="company.file2.length > 0 && company.file2 != 'loading'"><br>
				<md-progress-bar v-if="progress.file2.show" md-mode="determinate" :md-value="progress.file2.value">
				</md-progress-bar>
				<md-button class="md-primary" @click="openImage('file2')" v-if="company.file2.length == 0">ផ្ទុកឡើង
				</md-button>
				<md-button class="md-danger" @click="removeImage('file2')" v-else>ដកចេញ</md-button>
			</div>

			<div class="md-layout-item md-small-size-100 grid-8">
				ពត៍មានអំពីក្រុមហ៊ុន<br>
				<input type="file" ref="file3" style="display: none;" @change="processFile($event, 'file3')">
				<img class="thumb-product" src="/note_add.png" v-if="company.file3.length == 0">
				<img class="thumb-product" src="/loading-image.gif" v-if="company.file3 == 'loading'">
				<img class="thumb-product" src="/image-upload.png"
					v-if="company.file3.length > 0 && company.file3 != 'loading'"><br>
				<md-progress-bar v-if="progress.file3.show" md-mode="determinate" :md-value="progress.file3.value">
				</md-progress-bar>
				<md-button class="md-primary" @click="openImage('file3')" v-if="company.file3.length == 0">ផ្ទុកឡើង
				</md-button>
				<md-button class="md-danger" @click="removeImage('file3')" v-else>ដកចេញ</md-button>
			</div>

			<div class="md-layout-item md-small-size-100 grid-8">
				ផែនទី<br>
				<input type="file" ref="file4" style="display: none;" @change="processFile($event, 'file4')">
				<img class="thumb-product" src="/note_add.png" v-if="company.file4.length == 0">
				<img class="thumb-product" src="/loading-image.gif" v-if="company.file4 == 'loading'">
				<img class="thumb-product" src="/image-upload.png"
					v-if="company.file4.length > 0 && company.file4 != 'loading'"><br>
				<md-progress-bar v-if="progress.file4.show" md-mode="determinate" :md-value="progress.file4.value">
				</md-progress-bar>
				<md-button class="md-primary" @click="openImage('file4')" v-if="company.file4.length == 0">ផ្ទុកឡើង
				</md-button>
				<md-button class="md-danger" @click="removeImage('file4')" v-else>ដកចេញ</md-button>
			</div>

			<div class="md-layout-item md-small-size-100 grid-8">
				<b>Google Earth</b><br>
				<input type="file" ref="file5" style="display: none;" @change="processFile($event, 'file5')">
				<img class="thumb-product" src="/note_add.png" v-if="company.file5.length == 0">
				<img class="thumb-product" src="/loading-image.gif" v-if="company.file5 == 'loading'">
				<img class="thumb-product" src="/image-upload.png"
					v-if="company.file5.length > 0 && company.file5 != 'loading'"><br>
				<md-progress-bar v-if="progress.file5.show" md-mode="determinate" :md-value="progress.file5.value">
				</md-progress-bar>
				<md-button class="md-primary" @click="openImage('file5')" v-if="company.file5.length == 0">ផ្ទុកឡើង
				</md-button>
				<md-button class="md-danger" @click="removeImage('file5')" v-else>ដកចេញ</md-button>
			</div>
		</div>

		<md-divider style="margin: 21px 0 21px 0;"></md-divider>
		<div class="md-layout-item md-size-100 text-right">
			<md-button :class="{'md-raised': true, 'md-primary': isValid}" :disabled="!isValid"
				@click="updateCompany()">
				កែប្រែ</md-button>
		</div>
	</div>

</template>

<script>
	import { Datetime } from 'vue-datetime';
	import { Settings } from 'luxon'
	Settings.defaultLocale = 'km'
	export default {
		components: {
			datetime: Datetime
		},
		created() {
			this.getSettings();

		},
		data() {
			return {
				loaded: false,
				company: {
					name: "",
					owner: "",
					nationality: "",
					type: "",
					number: "",
					location: "",
					address: "",
					issue: "",
					active: "",
					expiry: "",
					area: "",
					status: "",
					phone: "",
					note: "",
					file1: "",
					file2: "",
					file3: "",
					file4: "",
					file5: ""
				},
				isValid: true,
				locationList: [],
				businessList: [],
				statusList: [],
				progress: {
					file1: { value: 0, show: false },
					file2: { value: 0, show: false },
					file3: { value: 0, show: false },
					file4: { value: 0, show: false },
					file5: { value: 0, show: false },
				}

			}
		},
		methods: {
			getSettings() {
				this.$http.get(this.config.api + "/public/location/get/list/0").then(data => {
					this.locationList = data.body.data
				})
				this.$http.get(this.config.api + "/public/business/get/list/0").then(data => {
					this.businessList = data.body.data
				})
				this.$http.get(this.config.api + "/public/status/get/list/0").then(data => {
					this.statusList = data.body.data
					this.getCompany();
				})
			},

			getCompany() {
				this.$http.get(this.config.api + "/admin/company/get/single_edit/" + this.$route.params.id).then(data => {
					this.company.name = data.body.data.name
					this.company.owner = data.body.data.owner
					this.company.nationality = data.body.data.nationality
					this.company.number = data.body.data.number
					this.company.address = data.body.data.address
					this.company.area = data.body.data.area
					this.company.phone = data.body.data.phone
					this.company.note = data.body.data.note
					this.company.location = data.body.data.location_id
					this.company.type = data.body.data.type_id
					this.company.status = data.body.data.status_id
					this.company.file1 = data.body.data.license_file
					this.company.file2 = data.body.data.plan_file
					this.company.file3 = data.body.data.info_file
					this.company.file4 = data.body.data.map_file
					this.company.file5 = data.body.data.earth_file

					this.company.issue = (new Date(data.body.data.issue_date * 1000)).toISOString();
					this.company.active = (new Date(data.body.data.active_date * 1000)).toISOString();
					this.company.expiry = (new Date(data.body.data.expiry_date * 1000)).toISOString();

					this.loaded = true
				})
			},
			updateCompany() {

				this.$http.post(this.config.api + "/admin/company/update", {
					company_id: this.$route.params.id,
					company: this.company,
					issue: (new Date(this.company.issue)).getTime(),
					active: (new Date(this.company.active)).getTime(),
					expiry: (new Date(this.company.expiry)).getTime(),
				}, {
					headers: {
						"Content-Type": "application/json"
					}
				}).then(res => {
					if (res.body.status == 'success') {
						this.tabName = 'first'
						this.$notification.notify({
							message: "ក្រុមហ៊ុនបានកែព័ត៌មានដោយជោគជ័យ។",
							icon: 'done',
							type: 'success'
						})
						this.$router.push('/companies');
					}
				})
			},
			processFile(e, file) {
				let files = e.target.files || e.dataTransfer.files;
				if (!files.length) return;

				this.company[file] = "loading";
				let formData = new FormData();

				formData.append("image", files[0], files[0].name);
				var self = this;
				this.$http.post(this.config.api + '/admin/file/upload', formData, {
					progress(e) {
						if (e.lengthComputable) {
							let progress = parseInt(e.loaded / e.total * 100);
							self.progress[file].show = true
							self.progress[file].value = progress
						}
					}
				}).then(res => {
					if (res.body.status == 'success') {
						this.progress[file].show = false;
						this.company[file] = res.body.data.file_name
						this.checkValidation();
					} else {
						this.company[file] = ""
					}
				})
			},
			openImage(id) {
				this.$refs[id].click();
			},
			removeImage(id) {
				this.company[id] = "";
				this.checkValidation();
			}
		}
	}
</script>
<style>
	.product-thumbnail {
		width: 64px;
		height: 64px;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50% !important;
	}

	.vdatetime-input {
		border: 0;
		width: 100%;
		height: 32px;
	}

	.vdatetime {
		width: 100%;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Loans/Edit.vue